import { Profile } from "../../../../../../services/types/enterpriseCoachingApiTypes";

export const isBlank = (v: string | null | undefined) => v == null || v.trim() === "";

// True when the saved profile has everything the contract requires (mobile phone and a full address).
export const isProfileComplete = (profile: Profile | null | undefined): boolean => {
    const addr = profile?.address;
    return !(
        isBlank(profile?.mobilePhone) ||
        isBlank(addr?.addressOne) ||
        isBlank(addr?.postalCode) ||
        isBlank(addr?.city) ||
        addr?.cmKey == null ||
        addr.cmKey <= 0 ||
        addr?.spmKey == null ||
        addr.spmKey <= 0
    );
};
